import { SVGProps } from 'react';

const InformationCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='#2656C6'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.4001 8.0001C14.4001 9.69748 13.7258 11.3253 12.5256 12.5256C11.3253 13.7258 9.69748 14.4001 8.0001 14.4001C6.30271 14.4001 4.67485 13.7258 3.47461 12.5256C2.27438 11.3253 1.6001 9.69748 1.6001 8.0001C1.6001 6.30271 2.27438 4.67485 3.47461 3.47461C4.67485 2.27438 6.30271 1.6001 8.0001 1.6001C9.69748 1.6001 11.3253 2.27438 12.5256 3.47461C13.7258 4.67485 14.4001 6.30271 14.4001 8.0001ZM8.8001 4.8001C8.8001 5.01227 8.71581 5.21575 8.56578 5.36578C8.41575 5.51581 8.21227 5.6001 8.0001 5.6001C7.78792 5.6001 7.58444 5.51581 7.43441 5.36578C7.28438 5.21575 7.2001 5.01227 7.2001 4.8001C7.2001 4.58792 7.28438 4.38444 7.43441 4.23441C7.58444 4.08438 7.78792 4.0001 8.0001 4.0001C8.21227 4.0001 8.41575 4.08438 8.56578 4.23441C8.71581 4.38444 8.8001 4.58792 8.8001 4.8001ZM7.2001 7.2001C6.98792 7.2001 6.78444 7.28438 6.63441 7.43441C6.48438 7.58444 6.4001 7.78792 6.4001 8.0001C6.4001 8.21227 6.48438 8.41575 6.63441 8.56578C6.78444 8.71581 6.98792 8.8001 7.2001 8.8001V11.2001C7.2001 11.4123 7.28438 11.6158 7.43441 11.7658C7.58444 11.9158 7.78792 12.0001 8.0001 12.0001H8.8001C9.01227 12.0001 9.21575 11.9158 9.36578 11.7658C9.51581 11.6158 9.6001 11.4123 9.6001 11.2001C9.6001 10.9879 9.51581 10.7844 9.36578 10.6344C9.21575 10.4844 9.01227 10.4001 8.8001 10.4001V8.0001C8.8001 7.78792 8.71581 7.58444 8.56578 7.43441C8.41575 7.28438 8.21227 7.2001 8.0001 7.2001H7.2001Z'
      />
    </svg>
  );
};

export default InformationCircle;
